export default __webpack_public_path__ + "static/media/award3.ce8fb7d2.jpg";